import React from "react";

import { Button, message } from "antd";

import ChangeSupplierDrawer from "../../orders-v2/change-supplier-drawer";

class ChangeSupplierButton extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            changeSupplierDrawerVisible: false
        };
    }

    render() {

        return (
            <div>
                <Button
                    disabled={this.getChangeSupplierButtonIsDisabled()}
                    onClick={this.onClickChangeSupplierButton}
                    type="danger"
                >
                    Change Supplier
                </Button>

                <ChangeSupplierDrawer
                    key={this.state.changeSupplierDrawerVisible}
                    productIds={this.props.productOrderIds}
                    visible={this.state.changeSupplierDrawerVisible}
                    orderId={this.props.cartId}

                    forProduct={false}
                    onChangeSupplier={this.props.onConfirm}

                    closeDrawer={() => this.setState({ changeSupplierDrawerVisible: false })}
                />
            </div>
        )

    }

    getChangeSupplierButtonIsDisabled = () => {

        return this.props.productOrderIds.length < 1;

    }

    onClickChangeSupplierButton = () => {

        if (this.props.productOrderIds.length === 0) {
            return message.warning("No products were selected");
        }

        this.setState({ changeSupplierDrawerVisible: true })

    }

}

export default ChangeSupplierButton;


// WEBPACK FOOTER //
// ./src/components/orders-v3/modal/change-supplier-button.js